import { useTranslation } from '../context/TranslationContext';
import './Legal.css';

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>{t('privacyPolicyPageTitle')}</h1>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>{t('collectionOfInfo')}</h2>
          <p>{t('collectionDesc')}</p>
        </section>
        <section className="legal-section">
          <h2>{t('useOfInfo')}</h2>
          <p>{t('useDesc')}</p>
        </section>
        <section className="legal-section">
          <h2>{t('dataReqDeletion')}</h2>
          <p>{t('dataReqDesc')}</p>
        </section>
      </div>
    </div>
  );
}
